// AI Copy Generation Hook (S024)
import { useState } from 'react';
import { apiClient } from '../lib/apiClient';

interface GenerateParams {
  prompt: string;
  tone: string;
  length: string;
  campaignId?: string;
}

interface GenerateResult {
  copy: string;
  id: string;
}

export const useCopyGeneration = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const generate = async (params: GenerateParams): Promise<GenerateResult | null> => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await apiClient.post('/api/v1/ai-copy/generate', params);
      return response.data;
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Failed to generate copy');
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { generate, isLoading, error };
};
